import React, {Component} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup} from "semantic-ui-react"

import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"

@observer
export default class CartButton extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0
		}
	}

	handleFetchWhoAmi = () => {
		console.log("handleFetchWhoAmi")
		shop.whoami()
	}

	render() {
		let { loading} = shop.cart
		let { sum } = shop.cart.data
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (sum > shop.config.MIN_ORDER_VALUE)

		//if ( !shop.session ) return null
		
		return (
			<div className=" relative">
				<Button
					primary
					loading={loading}
					className=""
					{...this.props}
					as={Link}
					to={{
						pathname: `/checkout/`,
						search  : queryString.stringify( {referer: document.location.pathname} )
					}}
					onClick={this.handleFetchWhoAmi}
					// onClick={app.sidebar.toggle.dispatch}
				>
					<Popup trigger={
						<React.Fragment>
							{!shop.session  ? <span><Icon className="shopping cart"></Icon></span> : shop.session && shop.session.shopuser && shop.session.shopuser.guest ? <span><Icon className="shopping cart"></Icon></span> : sum > 0 ? <Price>{sum}</Price> : <span><Price>0</Price></span>}
						</React.Fragment>
					}>

						<div>
							{!!MIN_ORDER_VALUE && <span>{translate( "min_order_value" )} <Price>{shop.config.MIN_ORDER_VALUE}</Price></span>}
							{(!MIN_ORDER_VALUE) && <span>Warenkorb anzeigen</span>}
						</div>
					</Popup>
				</Button>
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/theme/hvz/components/Cart/CartButton.js